import { CommentDotsRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";

const TrackingTextActivity = ({ activity, onReadChange }) => {
  const queryParams = new URLSearchParams();
  queryParams.set("messageUUID", activity.data?.messageUuid);

  return (
    <ActivityContainer activity={activity} queryParams={queryParams.toString()} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer
            containerClassName="tw-bg-[#FAF1E6] tw-text-[#AD6714]"
            Icon={CommentDotsRegularV6}
          >
            New Text
          </CategoryContainer>
        }
        personName={`${activity.data.senderName}${activity.data?.trackingNumberName ? ` to ${activity.data.trackingNumberName}` : ""}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        <span className={`${STYLES.lineClamp3} tw-px-8px`}>{activity.data.messageText}</span>
      </div>
    </ActivityContainer>
  );
};

export default TrackingTextActivity;

TrackingTextActivity.propTypes = {
  ...activityCommonPropTypes,
};

TrackingTextActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
